import styled from 'styled-components'
import colors from '../../../configuration/colors'

const Container = styled.div`
  width: 519px;
  border-radius: 20px;
  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);
  overflow: auto;
  background: ${colors.white};
  margin-bottom: 30px;
`

const HeaderBlock = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  margin: 0 auto;
  font-size: 20px;
  font-weight: 500;
  padding-bottom: 23px;
  width: 350px;
`

const ErrorHeaderBlock = styled.div`
  text-align: center;
  margin: 0 auto;
  font-size: 20px;
  font-weight: 500;
  padding-bottom: 23px;
  width: 350px;
`

const CancelButton = styled.button`
  font-size: 16px;
  background-color: ${colors.white};
  border: none;
  color: ${colors.victoria};
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  margin-right: 29px;
  padding: 0;
`

const SaveButton = styled.button`
  box-sizing: border-box;
  padding: 10px 0;
  width: 156px;
  border: 1px solid ${colors.oeYellow};
  border-radius: 20px;
  background: linear-gradient(270deg, ${colors.amber} 0%, ${colors.citron} 100%);
  box-shadow: 0 4px 2.85px 0.15px rgba(0,0,0,0.05);
  font-size: 16px;
  color: ${colors.charcoal2};
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  margin-right: 24px;
  &:disabled {
    background: ${colors.rock};
    border: 1px solid ${colors.rock};
    color: ${colors.white};
    box-shadow: none
  }
  &:disabled:hover{
    background: ${colors.rock};
    border: 1px solid ${colors.rock};
    color: ${colors.white};
    box-shadow: none
  }
  &:hover{
    background: linear-gradient(-45deg, ${colors.amberLite}, ${colors.turbo})
  }
`

const ModalQuestBlock = styled.div`
  display: flex;
  padding: 10px 23px;
  border-bottom: 1px solid ${colors.ash};
  align-items: center;
  align-content: center;
  background-color: ${colors.white};
  border: none;
  margin: 0 auto;
  padding: 0;
`

const Header = styled.h1`
  color: ${colors.victoria};
  font-family: 'Lato', sans-serif;
  font-size: 24px;
  font-weight: 500;
`

Header.displayName = 'Header'

const Message = styled.div`
  color: ${colors.charcoal4};
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 20.8px;
  text-align: center;
  padding: 0 80px 23px 80px;
  margin: 0 auto;
`
Message.displayName = 'Message'

const ButtonBlock = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 0 23px 0;
  border-top: 1px solid #eeeeee;
  padding-top: 23px;
`

const ModalTop = styled.div`
  padding: 23px 23px 0 23px;
  position: relative;
  border-bottom: 1px solid ${colors.ash};
  background-color: ${colors.white};
  border: none;
`

const CourseSectionName = styled.h1`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.victoria};
  padding-bottom: 23px;
  display: flex;
  width: fit-content;
  margin: 0 auto;
`

const GradeLevelContainer = styled.span`
  border: 0.84px solid ${colors.aluminum};
  border-radius: 3px;
  margin-right: 10px;
  position: relative;
  width: 16px;
  height: 16px;
  font-size: 9px;
  padding-top: 2px;
  padding-left: 0.7px;
`
GradeLevelContainer.displayName = 'GradeLevelContainer'

const OkayButton = styled.button`
  box-sizing: border-box;
  padding: 10px 0;
  width: 126px;
  border: 1px solid ${colors.oeYellow};
  border-radius: 20px;
  background: linear-gradient(270deg, ${colors.amber} 0%, ${colors.citron} 100%);
  box-shadow: 0 4px 2.85px 0.15px rgba(0,0,0,0.05);
  font-size: 16px;
  color: ${colors.charcoal2};
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  margin: 0 auto;
  &:disabled {
    background: ${colors.rock};
    border: 1px solid ${colors.rock};
    color: ${colors.white};
    box-shadow: none
  }
  &:disabled:hover{
    background: ${colors.rock};
    border: 1px solid ${colors.rock};
    color: ${colors.white};
    box-shadow: none
  }
  &:hover{
    background: linear-gradient(-45deg, ${colors.amberLite}, ${colors.turbo})
  }
`

const ErrorButton = styled.button`
  box-sizing: border-box;
  padding: 10px 0;
  width: 126px;
  border: 1px solid #999999;
  border-radius: 20px;
  font-size: 16px;
  color: #444444;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  margin-right: 24px;
  &:hover{
    border: 1px solid ${colors.black};
    color: ${colors.charcoal2};
    box-shadow: 0 6px 8px 0.15px rgba(0,0,0,.1);
  }
`

export {
  SaveButton,
  CancelButton,
  HeaderBlock,
  Message,
  ButtonBlock,
  ModalQuestBlock,
  Container,
  Header,
  ModalTop,
  CourseSectionName,
  GradeLevelContainer,
  OkayButton,
  ErrorButton,
  ErrorHeaderBlock
}
